import React from "react";
import CopywritePendingTitlingTable from "../../../../components/AllTable/CopywritePageTable/CopywritePendingTitlingTable";
import PendingTitlingWrapper from "./PendingTitlingWrapper";

const PendingTitlingPage = () => {
  return (
    <PendingTitlingWrapper>
      <CopywritePendingTitlingTable />
    </PendingTitlingWrapper>
  );
};

export default PendingTitlingPage;


























